module.exports = __webpack_public_path__ + "img/mobO.fd5a1731.svg";